
export default {
  camelCaseToSentence: (str) => {
    const specialCases = ['mcc', 'vfd'];
    if (specialCases.includes(str)) return str.toUpperCase();
    return str.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1").replace(/^./, (match) => {
      return match.toUpperCase();
    });
  },
  minWait: (fn, start, time = 250) => {
    const diff = new Date().getUTCMilliseconds() - start.getUTCMilliseconds();
    if (diff < time && diff > 0) {
      setTimeout(() => fn(), time - diff);
    } else {
      fn();
    }
  },
  getCookie(name) {
    function escape(s) {
      return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, "\\$1");
    }
    var match = document.cookie.match(
      RegExp("(?:^|;\\s*)" + escape(name) + "=([^;]*)")
    );
    return match ? match[1] : null;
  },
  downloadBlob(blob, title) {
    var fileURL = window.URL.createObjectURL(blob);
    var fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.setAttribute("download", title);
    document.body.appendChild(fileLink);
    fileLink.click();
  },
  async getNodeError(e) {
    if (e.response && e.response.data && e.response.data.text) {
      let text = await e.response.data.text();
      if (!text) return
      let obj = JSON.parse(text);
      if (obj) {
        return obj.err;
      }
    }
  }
};